<script>
import ButtonWrapper from "@/components/common/ButtonWrapper.vue";

export default {
  name: "MainToggleSwitch",
  components: { ButtonWrapper },

  emits: ["update:modelValue"],

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },

    darkMode: {
      type: Boolean,
      default: false,
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },

      set(newValue) {
        this.$emit("update:modelValue", newValue);
      },
    },
  },

  methods: {
    click() {
      if (this.isDisabled) {
        return;
      }

      this.$emit("update:modelValue", !this.localValue);
    },
  },
};
</script>

<template>
  <div class="main-toggle-switch">
    <input v-model="localValue" type="checkbox" :disabled="isDisabled" />
    <ButtonWrapper
      class="main-toggle-switch__slider slider"
      :class="{ slider_dark: darkMode }"
      @click="click"
    />
  </div>
</template>

<style lang="scss" scoped>
.main-toggle-switch {
  position: relative;
  display: inline-block;
  min-width: 44px;
  width: 44px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:checked + .slider {
    background: rgba(255, 218, 122, 0.2);
    border: 1px solid $gold;
  }

  input:focus + .slider {
    border: 1px solid $gold;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(18px);
    -ms-transform: translateX(18px);
    transform: translateX(18px);
    background-color: $gold;
  }

  input:disabled + .slider {
    opacity: 0.5;
  }
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $new-dark-second;
  border: 1px solid $new-dark-third;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 28px;

  &:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 3px;
    background-color: $new-dark-third;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }

  &_dark {
    background-color: $new-dark-primary;
  }
}
</style>
